import { Instance } from 'mobx-state-tree'
import { PaginatedUserGamesModelBase } from './PaginatedUserGamesModel.base'

/* The TypeScript type of an instance of PaginatedUserGamesModel */
export interface PaginatedUserGamesModelType extends Instance<typeof PaginatedUserGamesModel.Type> {}

/* A graphql query fragment builders for PaginatedUserGamesModel */
export {
  selectFromPaginatedUserGames,
  paginatedUserGamesModelPrimitives,
  PaginatedUserGamesModelSelector
} from './PaginatedUserGamesModel.base'

/**
 * PaginatedUserGamesModel
 */
export const PaginatedUserGamesModel = PaginatedUserGamesModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
